import {
  messageId,
  PropertyMeta,
  ValueObjectMetaString,
} from "@pscsrvlab/psc-react-components";
import { z } from "zod";
const minimalSchema = z.string().max(10000);
const savedMinimalSchema = z.string().max(10000);
const schema = z.string().min(1).max(10000);
const savedSchema = z.string().min(1).max(10000);
const jsonSchema = z.string();
/**
 * 問題対応内容(値オブジェクト)のメタデータ。
 *
 *  */
export const responseToProblemMeta = new ValueObjectMetaString(
  "ResponseToProblem",
  "\u554F\u984C\u5BFE\u5FDC\u5185\u5BB9",
  messageId("lbl.\u554F\u984C\u5BFE\u5FDC\u5185\u5BB9"),
  minimalSchema,
  schema,
  jsonSchema,
  undefined,
  undefined
);
